// Tooltipster wide (pour tableaux dans popover)
$(document).ready(function() {
  if ($.fn.tooltipster) {
    $('.tooltip--wide').tooltipster({
      theme: ['tooltipster-noir', 'tooltipster-noir-customized', 'tooltipster-wide'],
      animation: 'fade',
      delay: 200,
      zIndex: 200,
      contentAsHTML: true,
      maxWidth: 700,
      side: ['bottom', 'top'],
      trigger: 'custom',
      triggerOpen: { mouseenter: true, tap: true },
      triggerClose: { mouseleave: true, tap: true }
    });
  }
});

// Ouvre la section masquée si un champ invalide s'y trouve
// invalid ne bubble pas, on utilise la phase de capture
document.addEventListener('invalid', function(e) {
  var $section = $(e.target).closest('.o-js-funds_filters-sub');
  if ($section.length && $section.is(':hidden')) {
    $section.show();
  }
}, true);

// Toggle champ "Autres" pour la catégorisation MIF
function toggleMifOther() {
  var $mifSelect = $('[data-mif-other-trigger]');
  var $otherField = $('[data-mif-other-field]');
  if ($mifSelect.length && $otherField.length) {
    if ($mifSelect.val() === 'other') {
      $otherField.show();
    } else {
      $otherField.hide();
    }
  }
}

// Délégation au niveau document pour capter les events Select2
$(document).on('change', '[data-mif-other-trigger]', toggleMifOther);

$(document).ready(function() {
  // État initial (y compris en mode édition avec "autres" déjà sélectionné)
  toggleMifOther();
  if( $('#js-form-pro').is('*')) {
    function is_checked(selector, field) {
      if ($(selector).is(':checked')) {
        $(field).removeClass('hide');
        $(field).find('input').prop('disabled', false);
        $(field).find('select').prop('disabled', false);
      } else {
        $(field).addClass('hide');
        $(field).find('input').prop('disabled', true);
        $(field).find('select').prop('disabled', true);
      }
    }

    is_checked('#user_company_attributes_is_using_vat_number', '.user_company_vat_number');

    $('#user_company_attributes_is_using_vat_number').change(function() {
      is_checked(this, '.user_company_vat_number');
    });

    // Toggle statuts réglementaires
    $('.js-regulatory-status-toggle').each(function() {
      var targetId = $(this).data('target');
      var $details = $('#' + targetId);
      if (!$(this).is(':checked')) {
        $details.find('input, select, textarea').prop('disabled', true);
      }
    });

    $('.js-regulatory-status-toggle').on('change', function() {
      var targetId = $(this).data('target');
      var $details = $('#' + targetId);
      if ($(this).is(':checked')) {
        $details.slideDown(200);
        $details.find('input, select, textarea').prop('disabled', false);
      } else {
        $details.slideUp(200);
        $details.find('input, select, textarea').prop('disabled', true);
      }
    });
  }

});